import { define } from 'wicked-elements'

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

define('[data-component="autoplay-video"]', {
  init() {
    this.checkLowPowerMode()
  },

  async checkLowPowerMode() {
    try {
      // Check if the device is in low power mode
      const isLowPowerMode = await navigator.getBattery?.()?.then(battery => battery.powerSaveMode) ?? false
      
      if (isLowPowerMode) {
        this.switchToImage()
      } else {
        this.setupVideo()
      }
    } catch (error) {
      // If we can't check power mode, default to video
      this.setupVideo()
    }
  },

  switchToImage() {
    const video = this.element
    const videoSrc = video.querySelector('source')?.src || video.src
    if (!videoSrc) return

    const img = document.createElement('img')
    img.src = videoSrc
    img.alt = video.getAttribute('alt') || ''
    img.className = video.className
    
    // Copy over video attributes that might be relevant for the image
    img.setAttribute('playsinline', '')
    img.setAttribute('muted', '')
    img.setAttribute('loop', '')
    
    video.parentNode.replaceChild(img, video)
  },

  setupVideo() {
    const video = this.element
    video.muted = true
    video.playsInline = true
    video.loop = true
    
    // Start playing when the video is ready
    video.addEventListener('loadeddata', () => {
      video.play().catch(() => {

        // If autoplay fails in Safari, fall back to image tag
        if (isSafari) {
          this.switchToImage()
        }
      })
    })
  }
})